import React, { useEffect } from "react";
import {
  Breadcrumb,
  Button,
  Col,
  InputGroup,
  Row,
  Form,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import { routes, PUBLIC_API_DOCUMENTATION_URL } from "../../../common/constants";
import { SearchIcon } from "../../../components/ui/icons";
import "./flashcast.scss";
import TableView from "../../../components/tableView";
import FlashcastColumns from "./flashcastColumns";
import CreatePublicTokenModal from "../../../components/createPublicTokenModal";
import { getPublicApiApprovalStatus, selector } from "../approvePublicApiUserSlice";
import useFlashcastTable from "./useFlashcastTable";
import useFlashcast from "./useFlashcast";
import { useDispatch, useSelector } from "react-redux";
import {  RootState } from '../../../store';

const Flashcast = () => {
  const dispatch = useDispatch<RootState>();
  const flashcastColumns = FlashcastColumns();
  const { rows, globalFilter, setGlobalFilter, noDataMessage } = useFlashcast();
  const { isSuperAdminApproved } = useSelector(selector);

  const { handleSearchSubmit, searchTerm, handleSearchChange } =
    useFlashcastTable();

    useEffect(() => {
      if(isSuperAdminApproved == undefined || null) {
        dispatch(getPublicApiApprovalStatus());
      }
    }, [dispatch]);

  return isSuperAdminApproved ? (
    <div className="integration-container">
      <div className="integration-header">
        <div className="integration-header-content">
          <div className="integration-heading">3rd Party Integration</div>
          <a href={PUBLIC_API_DOCUMENTATION_URL} target="_blank" rel="noopener noreferrer">
          View Flashcast Public API Guide
          </a>
        </div>
        <Row>
          <Col sm={6}>
            <div className="integration-breadcrumb">
              <Breadcrumb>
                <Breadcrumb.Item
                  linkAs={Link}
                  linkProps={{ to: `${routes.integrations}` }}
                >
                  3rd Party Integration
                </Breadcrumb.Item>
                <Breadcrumb.Item active>
                  Flashcast Configuration
                </Breadcrumb.Item>
              </Breadcrumb>
            </div>
          </Col>
          <Col sm={2}></Col>
          <Col sm={4}>     
            <div className="dm-search-input">
              <Form onSubmit={(e) => handleSearchSubmit(e, setGlobalFilter)}>
                <InputGroup>
                  <Form.Control
                    placeholder="Search by Token Name"
                    aria-label="Search"
                    aria-describedby="basic-addon2"
                    value={searchTerm}
                    onChange={handleSearchChange}
                  />
                  <Button
                    id="search-tree-list"
                    onClick={(e) => handleSearchSubmit(e, setGlobalFilter)}
                  >
                    <SearchIcon />
                  </Button>
                </InputGroup>
              </Form>
            </div>
          </Col>
        </Row>
      </div>
      <div className="integration-body">
        <Row>
          <Col sm={2} className="label">
            <h5>Tokens</h5>
          </Col>
          <Col sm={7}></Col>
          <Col sm={3}>
          <div className="integration-config-btn">
              <CreatePublicTokenModal />
          </div>
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <div className="dm-table-container">
              <TableView
                data={rows}
                columns={flashcastColumns}
                globalFilter={globalFilter}
                setGlobalFilter={setGlobalFilter}
                noDataMessage={noDataMessage}
              />
            </div>
          </Col>
        </Row>
      </div>
    </div>
  ) : (
    <div className="approval-required-container">
      <h1>Super Admin Approval Required</h1>
    </div>
  );
};

export default Flashcast;
